import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import classNames from 'classnames';
import AbstractTextElement from './AbstractTextElement';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Big(_ref) {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AbstractTextElement, Object.assign({}, rest, {
    className: classNames('private-big', className)
  }));
}
Big.propTypes = AbstractTextElement.propTypes;
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
Big.defaultProps = AbstractTextElement.defaultProps;
Big.displayName = 'Big';